import { Card } from "antd";
import { ReactNode } from "react";

interface IDetailHeader {
  title: string;
  subtitle?: string;
  extra?: ReactNode;
}

const DetailHeader = (props: IDetailHeader) => {
  const { title, subtitle, extra } = props;

  return (
    <Card
      className="bg-gradient-to-r from-gray-50 to-white rounded-xl shadow-sm 
                [&_.ant-card-body]:px-6 [&_.ant-card-body]:py-4 border border-gray-200"
    >
      <div className="flex justify-between items-center gap-4 flex-wrap">
        <div>
          <h2 className="text-2xl font-semibold text-gray-800 m-0">{title}</h2>
          {subtitle ? (
            <p className="text-gray-500 text-base mt-1">{subtitle}</p>
          ) : null}
        </div>
        {extra ? <div className="shrink-0">{extra}</div> : null}
      </div>
    </Card>
  );
};

export default DetailHeader;
